import { familyResources } from 'utils/product/configs'
export const familyDomain = familyResources.name
